import { gsap } from "gsap";

function setup(container) {
    const title = container.querySelectorAll('.link-holder-card-showcase__prefix, .link-holder-card-showcase__title, .link-holder-card-showcase__action')
    const items = Array.from(container.querySelectorAll('.link-holder-card'))

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: container,
            start: 'top 75%',
            end: 'bottom top',
            //markers: true
        }
    })

    tl.addLabel("start")

    tl.from(title, {
        opacity: 0,
        translateY: '10px',
        stagger: 0.1
    })

    tl.from(items, {
        opacity: 0,
        translateY: '10px',
        stagger: 0.05
    })

    items.forEach((item, i) => {
        const children = item.children

        tl.from(children, {
            delay: i / 10,
            opacity: 0,
            translateY: '10px',
            stagger: 0.1
        }, "<")
    })
}

export default () => {
    const els = Array.from(document.querySelectorAll('.link-holder-card-showcase'))

    if (!els) return;

    els.forEach(setup)
}
